module.exports = __webpack_public_path__ + "img/pv_icon_table.3a2edc97.svg";